export const getJourneySegmentIdentifiers = (journeyDetails) => {
  if (journeyDetails.segments) {
    const segmentIdentifiers = journeyDetails.segments.map((segmentInfo) => {
      const { identifier } = segmentInfo;

      if (!identifier) {
        return "";
      }

      const carrierCode = Array.isArray(identifier.carrierCode)
        ? identifier.carrierCode.join("")
        : identifier.carrierCode;
      const segmentCode = Array.isArray(identifier.identifier) ? identifier.identifier.join("") : identifier.identifier;

      return `${carrierCode} ${segmentCode}`;
    });

    // Join the segment identifiers for all segments in the journey
    return segmentIdentifiers.join(", ");
  }

  return "";
};
